import { api, handleError } from "./baseApi";

export async function getWalletById(userId) {
  try {
    const { data } = await api.get(`/wallet/${userId}`);
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function createWallet(walletId, wallet) {
  try {
    const { data } = await api.post(`/wallet/${walletId}`, {
      points: wallet.points,
      type: wallet.depositType,
      reference_type: wallet.referenceType,
      description: wallet.comment || "",
      reference_id: wallet.referenceId || "",
      initiator_id: wallet.initiatorEmail,
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}
